import { ceil, keys } from "lodash";
import { Line } from "react-chartjs-2";
import { Loader } from "../../../components/loader";
import { useFetchable } from "../../../store/common/fetchable";
import { Verification } from "../../../store/verification/reducer";
import { chartColours } from "../../../styles/colours";
import { FraudRoutes } from "../../kyc-kyb-aml/routes";
import { StyledTextWidget } from "./common";

export const VerificationChecksTile = () => {
  const verificationChecksSummaryFetchable = useFetchable(
    Verification.checksSummary
  );

  return (
    <Loader data={[verificationChecksSummaryFetchable]}>
      {([verifcationChecks]) =>
        keys(verifcationChecks.kybChecks?.totalPerWeek || {}).length < 1 &&
        keys(verifcationChecks.kycChecks?.totalPerWeek || {}).length <
          1 ? null : (
          <StyledTextWidget
            title="Recent Identity Checks:"
            center
            to={FraudRoutes.names.allIndividualKyc}
          >
            <Line
              data={{
                labels: (verifcationChecks.kycChecks?.totalPerWeek || []).map(
                  (x) => x.date
                ),
                datasets: [
                  {
                    label: `Know your Customer`,
                    data: (verifcationChecks.kycChecks?.totalPerWeek || []).map(
                      (x) => x.count
                    ),
                    fill: { target: "start", above: chartColours.black.light },
                    borderColor: chartColours.black.main,
                    pointRadius: 1,
                  },
                  {
                    label: "Know your Business",
                    data: (verifcationChecks.kybChecks?.totalPerWeek || []).map(
                      (x) => x.count
                    ),
                    fill: { target: "start", above: chartColours.blue.light },
                    borderColor: chartColours.blue.main,
                    pointRadius: 1,
                  },
                ],
              }}
              options={{
                scales: {
                  y: {
                    min: 0,
                    max: ceil(
                      Math.max(
                        verifcationChecks.kycChecks?.maxPerWeek || 0,
                        verifcationChecks.kybChecks?.maxPerWeek || 0
                      ) * 1.1
                    ),
                  },
                },
                elements: {
                  line: {
                    tension: 0.4,
                  },
                },
              }}
            />
          </StyledTextWidget>
        )
      }
    </Loader>
  );
};
